module.exports = __webpack_public_path__ + "img/sweet-spot-header-copy.a47385ae.png";